import { object, string } from 'yup';
import '@client/yup';

export const SignupArtistAccountsSchema = object().shape({
  websiteUrl: string().label('Website').http().url(),
  spotifyArtistUrl: string().label('Spotify profile URL').trim().streamingUri('Spotify profile URL'),
  videoUri: string().label('Youtube video URL').trim().streamingUri('Youtube video URL'),
});
